import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { OrgAdminSidebarComponent } from '../sidebar/org-admin-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';

@Component({
  selector: 'app-org-admin-mdm',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    OrgAdminSidebarComponent,
    PageHeaderComponent,
  ],
  templateUrl: './mdm.component.html',
  styleUrl: './mdm.component.scss',
})
export class OrgAdminMdmComponent {}



